// Los cuatro valores de alfa que ofrece la interfaz, con la clave del archivo
// de ratings y la etiqueta que se muestra. Viven aqui porque los usan el
// selector (dentro de la leyenda), el panel de la celda y el tooltip.
export const ALPHAS = [
  { clave: '000', etiqueta: '0' },
  { clave: '025', etiqueta: '0.25' },
  { clave: '050', etiqueta: '0.5' },
  { clave: '100', etiqueta: '1.0' },
];

export const ETIQUETA_ALPHA = Object.fromEntries(
  ALPHAS.map(({ clave, etiqueta }) => [clave, etiqueta])
);
